import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GalleryRequestSearch } from '../../../models/api-dam/gallery/gallery-request.model';
import { GalleryService } from '../../../services/api-dam/gallery/gallery.service';
import { FALSE } from '../../../utils/config/const';

@Component({
  selector: 'app-choice-galleries-modal',
  templateUrl: './choice-galleries-modal.component.html'
})
export class ChoiceGalleriesModalComponent implements OnInit {

  isButtonSaveDisabled: boolean;
  constructor(
    public activeModal: NgbActiveModal,
    private galleryService: GalleryService
  ) { }

  ngOnInit(): void {
    this.isButtonSaveDisabled = true;
  }

  //Autocomplete - galleryIds <- Galleria immagini
  @ViewChild('galleryIds') galleryIds;
  galleryIdsKeyword = 'name';
  galleryIdsSuggestion: any = [];
  galleryIdsSelected: any = [];
  errorMsg: string = "Nessuna galleria trovata...";
  isGalleryIdsKeywordLoadingResult: boolean;
  getGalleryIdsRequest(event) {
    let request = new GalleryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0;
    request.pageSize = 20;
    return request;
  }
  fill_galleryIdsSuggestion(response){
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.galleryIdsSelected.length && !trovato; j++) {
        if (obj.id == this.galleryIdsSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.galleryIdsSuggestion.push(obj);
      }
    }
  }
  getGalleryIdsList(event) {
    this.isGalleryIdsKeywordLoadingResult = true;
    let request = this.getGalleryIdsRequest(event);
    this.galleryService.search(request).subscribe(response => {
      this.galleryIdsSuggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_galleryIdsSuggestion(response);
      }
      this.isGalleryIdsKeywordLoadingResult = false;
    });
  }
  searchGalleryIdsCleared() {
    this.galleryIdsSuggestion = [];
  }
  selectGalleryIdsEvent(item) {
    this.isButtonSaveDisabled = false;
    this.galleryIdsSelected.push(item);
    this.galleryIds.clear();
  }
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  onGalleryIdsFocused(e) {
    console.log(e);
    this.getGalleryIdsList("");
    // do something when input is focused
  }
  //Chip list - galleryIds <- Galleria immagini
  labelKeysGalleryIds = ["name"];
  onChangeItemListGalleryIdsSelected($event) {
    if ($event != null) {
      if ($event.length > 0) {
        this.isButtonSaveDisabled = false;
      } else {
        this.isButtonSaveDisabled = true;
      }
    } else {
      this.isButtonSaveDisabled = true;
    }
  }


  clickButtonSave() {
    if (this.isButtonSaveDisabled == FALSE) {
      this.activeModal.close(this.galleryIdsSelected);
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

}
